import React, { useContext, useEffect, useState,useRef } from 'react';
import {
  Box,
  Button,
  FormLabel,
  Grid,
  GridItem,
  Icon,
  Img,
  Input,
  position,
  SimpleGrid,
  Text,
  useBreakpointValue,
  useToast,
} from '@chakra-ui/react';

import * as THREE from 'three';
// Three js
import { Canvas } from 'react-three-fiber';
import { ProfileContext } from '../EntirePreview';

import { useParams } from 'react-router-dom';

interface PlayGamesProps {
  formData?: any;
  state?: any;
  dispatch?: any;
  setDatas?: any;
  imageSrc?: any;
  setCurrentScreenId?: any;
  players?: any;
  setSelectedPlayer?: any;
  profileData?: any;
  setProfileData?: any;
  demoBlocks?: any;
  preloadedAssets?: any;
  currentScreenId: any;
  setPreLogDatas: any;
  getPrevLogDatas: any;
  ModelPlayer: any;
  backgroundtheme: any;
  selectedBackground: any;
}

const IsErrorInitialState: { name: string | null } = { name: null };
const spokenLanguages = [
  'English',
  'Spanish',
  'Mandarin Chinese',
  'Hindi',
  'French',
  'Arabic',
  'Bengali',
  'Russian',
  'Portuguese',
  'Urdu',
  'Indonesian',
  'German',
  'Japanese',
  'Swahili',
  'Turkish',
  'Italian',
  'Thai',
  'Dutch',
  'Korean',
  'Vietnamese',
];

const Characterspage: React.FC<PlayGamesProps> = ({
  state,
  dispatch,
  setDatas,
  imageSrc,
  setCurrentScreenId,
  players,
  setSelectedPlayer,
  profileData,
  setProfileData,
  demoBlocks,
  formData,
  preloadedAssets,
  currentScreenId,
  setPreLogDatas,
  getPrevLogDatas,
  ModelPlayer,
  backgroundtheme,
  selectedBackground,
}) => {
  const [toggleLeft, setToggleLeft] = useState(false);
  const [toggleRight, setToggleRight] = useState(false);
  const [blackScreen, setBlackScreen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const toast = useToast();
  const useData = useContext(ProfileContext);
  const { id } = useParams();
  const Gameid = id ? id : null;
  const [isEditing, setIsEditing] = useState(false);
  const [isError, setIsError] = useState(IsErrorInitialState);

  const [formState, setFormState] = useState<any>({
    name: Gameid
      ? getPrevLogDatas?.previewProfile?.name
        ? getPrevLogDatas.previewProfile.name
        : profileData.name
      : profileData.name,
  });
  
  const [blinking, setBlinking] = useState(false);

 const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const selectPlayerClick = () => {
    // Perform form validation
    const Errors = {
      name:
        formState.name.trim() === ''
          ? 'Please Enter Your Name.'
          : null,
    };

    // Set the error state
    setIsError(Errors);

    // Check if any error is present
    const isErrorPresent = Object.values(Errors).some(
      (error) => error !== null,
    );

    if (isErrorPresent) {
      // Show a toast notification for the error
      toast({
        // title: 'Validation Error',
        description: Errors.name, // The error message
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      // Proceed with the rest of the logic if no errors
      setProfileData((prev: any) => ({
        ...prev,
        name: formState.name, // Update the name in profile data
      }));

      if (Gameid) {
        setPreLogDatas((prev: any) => ({
          ...prev,
          previewProfile: {
            ...prev.previewProfile,
            name: formState.name, // Update the name in the pre-log data
          },
        }));
      }

      // Trigger any motion effect or transition
      useData?.setMotionEffect(true);

      setTimeout(() => {
        // Set the selected player and transition to the next screen
        const i = 0; // Assuming you are referring to a specific player index
        if (Gameid) {
          setPreLogDatas((prev: any) => ({
            ...prev,
            screenIdSeq: [currentScreenId],
            previewProfile: {
              ...prev.previewProfile,
              selectedPlayer: players[i],
            },
          }));
        }

        // Set the selected player
        setSelectedPlayer(players[i]);
        setCurrentScreenId(13); // Navigate to Chapter selection
      }, 300);
    }
  };

  // }
  const innerBoxWidth = useBreakpointValue({
    base: '95%',
    lg: '95%',
    xl: '90%',
    xxl: '90%',
  });

  useEffect(() => {
    setFormState({
      name: Gameid
        ? getPrevLogDatas?.previewProfile?.name
          ? getPrevLogDatas.previewProfile.name
          : profileData.name
        : profileData.name,
    });

    // }
  }, [getPrevLogDatas]);

  const SelectedBackgroundTheme =
    backgroundtheme &&
    backgroundtheme?.find((find: any) => find.gasId === selectedBackground);

  let theme: string | string[] = '';
  if ([1, 2, 3].includes(SelectedBackgroundTheme?.gasId)) {
    theme = 'Medieval';
  } else if ([4, 5, 6].includes(SelectedBackgroundTheme?.gasId)) {
    theme = 'Future';
  } else if ([10, 11, 12].includes(SelectedBackgroundTheme?.gasId)) {
    theme = 'Real';
  } else if ([7, 8, 9].includes(SelectedBackgroundTheme?.gasId)) {
    theme = ['Magical'];
  }

  const matchingCharacter = preloadedAssets?.Player_Image?.filter((char: any) =>
    Array.isArray(theme) ? theme.includes(char.theme) : char.theme === theme,
  );

  const [selectedCharacter, setSelectedCharacter] = useState(
    matchingCharacter[0],
  );

  const [selectedIndex, setSelectedIndex] = useState(0); // Initialize index as 0

  const getTexture = (selected: number): THREE.Texture => {
    const asset = selectedCharacter;

    return new THREE.TextureLoader().load(asset?.src);
  };

  useEffect(() => {
    if (selectedCharacter?.id) {
      setProfileData((prev: any) => ({
        ...prev,
        gender: selectedCharacter?.id,
        selectedplayer: selectedCharacter?.name,
      }));
    }
  }, [selectedCharacter]);

  return (
    <>
      <Img
        src={preloadedAssets.Login}
        onLoad={() => setLoaded(true)}
        display={'none'}
      />
      {loaded && (
        <Box
          position="relative"
          w={'100%'}
          height="100vh"
          // backgroundImage={preloadedAssets.StarsBg}
          backgroundImage={preloadedAssets?.introBgImage}
          backgroundColor={'#0d161e'}
          backgroundSize={'cover'}
          backgroundRepeat={'no-repeat'}
          className="CharacterScreen chapter_potrait"
        >
          <Grid
            templateColumns="repeat(1, 1fr)"
            gap={4}
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            width="100%"
          >
            <GridItem colSpan={1} position={'relative'}>
              <Box display={'flex'} justifyContent={'center'}>
                <Img
                  src={preloadedAssets.Select}
                  className={'character_template'}
                  loading="lazy"
                />
                <Box className={'character_select_area'}>
                  <Box
                    className="child_of_character_select_area"
                    w={'55%'}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                  >
                    <img
                      src={preloadedAssets.Selected}
                      className={`character_toggle_left ${
                        toggleLeft ? 'toggle_effect_on' : 'toggle_effect_off'
                      }`}
                      onMouseDown={() => {
                        setToggleLeft(true);

                        setSelectedIndex((prevIndex) => {
                          const newIndex =
                            (prevIndex - 1 + matchingCharacter.length) %
                            matchingCharacter.length;
                          setSelectedCharacter(matchingCharacter[newIndex]); // Update character
                          return newIndex;
                        });
                      }}
                      onMouseUp={() => setToggleLeft(false)}
                      alt="Toggle Left"
                    />

                    <Canvas
                      style={{
                        width: window.innerWidth < 520 ? '100%' : '140%',
                        height: window.innerWidth < 520 ? '100%' : '160%',
                      }}
                      camera={{ position: [0, 1, 9] }}
                      dpr={window.devicePixelRatio}
                    >
                      {' '}
                      {/* For Single view */}
                      {/* <Environment preset={"park"} background />   */}
                      <directionalLight
                        position={[2.0, 78.0, 100]}
                        intensity={0.8}
                        color={'ffffff'}
                        castShadow
                      />
                      <ambientLight intensity={0.5} />
                      <pointLight position={[1.0, 4.0, 0.0]} color={'ffffff'} />
                      <sprite
                        position={[0, 1, 3.5]}
                        rotation={[0, 0, 0]}
                        scale={
                          selectedCharacter?.id === 'male' &&
                          selectedCharacter?.theme === 'Medieval'
                            ? [5, 8, 1]
                            : selectedCharacter?.id === 'female' &&
                              selectedCharacter?.theme === 'Medieval'
                            ? [5, 8, 1]
                            : selectedCharacter?.id === 'male' &&
                              selectedCharacter?.theme === 'Real'
                            ? [5, 8, 1]
                            : selectedCharacter?.id === 'female' &&
                              selectedCharacter?.theme === 'Real'
                            ? [5, 8.2, 1]
                            : selectedCharacter?.id === 'male' &&
                              selectedCharacter?.theme === 'Future'
                            ? [5, 8.7, 1]
                            : selectedCharacter?.id === 'female' &&
                              selectedCharacter?.theme === 'Future'
                            ? [5, 8, 1]
                            : selectedCharacter?.id === 'male' &&
                              selectedCharacter?.theme === 'Magical'
                            ? [5, 8.7, 1]
                            : selectedCharacter?.id === 'female' &&
                              selectedCharacter?.theme === 'Magical'
                            ? [5, 8, 1]
                            : [5, 8, 1] // Default scale
                        }
                      >
                        <spriteMaterial
                          attach="material"
                          // ## Updated map logic to use selectedCharacter state
                          map={getTexture(selectedCharacter)}
                        />
                      </sprite>
                    </Canvas>
<Box className='blinking-wave-character-select'
w={'7vw'}
h={'7vh'}
>
                    <img
                      src={preloadedAssets.Selected}
                      className={`character_toggle_right ${
                        toggleRight ? 'toggle_effect_on' : 'toggle_effect_off'
                      }`}
                      onMouseDown={() => {
                        setToggleRight(true);

                        setSelectedIndex((prevIndex) => {
                          const newIndex =
                            (prevIndex + 1) % matchingCharacter.length;
                          setSelectedCharacter(matchingCharacter[newIndex]); // Update character
                          return newIndex;
                        });
                      }}
                      onMouseUp={() => setToggleRight(false)}
                      alt="Toggle Right"
                    />
                    </Box>
                  </Box>
                </Box>
                <Box className={'select_player'}>
                  <Button
                    w={'15%'}
                    bg={'none'}
                    className="mouse_style"
                    _hover={{ bg: 'none' }}
                    onClick={selectPlayerClick}
                  ></Button>
                </Box>
                <Box className={'character_next'}>
                  <Box className={'character_buttons'}>
                    <Button
                      marginLeft={'20px'}
                      className="btns left-btn mouse_style leftside-buttons"
                      bg={'none'}
                      _hover={{ bg: 'none' }}
                      onClick={() => {
                        setBlackScreen(true);

                        setTimeout(() => {
                          setCurrentScreenId(1);
                        }, 1000);
                      }}
                    ></Button>

                    <Box
                      w={'40%'}
                      position={'relative'}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {/* {isEditing ? (
                        <Input
                          // value={name}
                           style={{
      width: '100%',
      padding: '5px',
      border: 'none',
      outline: 'none',
      textAlign: 'center',
      background: 'transparent',
      boxShadow:'none',
    }}
                          placeholder={isEditing && formState.name.trim() === 'Enter Your Name' ? 'Enter Your Name' : 'Enter Your Name'} 
                         
                          textAlign={'center'}
                          className="player_name"
                          value={formState.name}
      //                     onChange={(e) =>
      //                       setFormState({ ...formState, name: e.target.value })
      //                        if (typingTimeoutRef.current) {
      //   clearTimeout(typingTimeoutRef.current);
      // }

      // // Don't blink while typing
      // setBlinking(false);

      // // Blink only after typing stops
      // typingTimeoutRef.current = setTimeout(() => {
      //   setBlinking(true);
       
      // }, 700);
      //                     }
       onChange={(e) => {
     setFormState({ ...formState, name: e.target.value })

      // Clear previous timeout
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }

      // Don't blink while typing
      setBlinking(false);

      // Blink only after typing stops
      typingTimeoutRef.current = setTimeout(() => {
        setBlinking(true);
       
      }, 700);
    }}
                        />
                      ) */}
                      {isEditing || formState.name.trim() === '' ? (
  <Input
    style={{
      width: '100%',
      padding: '5px',
      border: 'none',
      outline: 'none',
      textAlign: 'center',
      background: 'transparent',
      boxShadow: 'none',
    }}
    placeholder="Enter Your Name"   // ALWAYS show on empty initial load
    textAlign="center"
    className="player_name"
    value={formState.name}
    onChange={(e) => {
      setFormState({ ...formState, name: e.target.value });

      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }

      setBlinking(false);

      typingTimeoutRef.current = setTimeout(() => {
        setBlinking(true);
      }, 700);
    }}
  />
) : (
  <FormLabel
    style={{ width: '100%' }}
    className="player_name"
    textAlign="center"
    me={0}
    mb={1}
    onClick={() => setIsEditing(true)}
  >
    {Gameid ? profileData?.name : formState.name}
  </FormLabel>
)}

                       {/* : (
                        <FormLabel
                          style={{ width: '100%' }}
                          className="player_name"
                          textAlign={'center'}
                          me={0}
                          mb={1}
                          onClick={() => setIsEditing(true)}
                        >
                          {Gameid ? profileData?.name : formState.name}
                        </FormLabel>
                      )} */}
                    </Box>
                    <Button
                      className={`btns right-btn mouse_style rightside-buttons ${blinking ? 'blinking-wave-new' : ''}`}
                      bg={'none'}
                      _hover={{ bg: 'none' }}
                      onClick={selectPlayerClick}
                    ></Button>
                  </Box>
                </Box>
              </Box>
            </GridItem>
          </Grid>
        </Box>
      )}
      {/* </Box> */}
    </>
  );
};

export default Characterspage;
